var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSportScoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354-716h69.5v-69.5H354v69.5Zm139 0v-69.5h69.5v69.5H493ZM354-438v-69.5h69.5v69.5H354Zm278-139v-69.5h69.5v69.5H632Zm0 139v-69.5h69.5v69.5H632Zm-139 0v-69.5h69.5v69.5H493Zm139-278v-69.5h69.5v69.5H632Zm-208.5 69.5V-716H493v69.5h-69.5ZM259-191.5v-594h25.5v69.5H354v69.5h-69.5v69.5H354v69.5h-69.5v316H259Zm303.5-316V-577H632v69.5h-69.5Zm-139 0V-577H493v69.5h-69.5ZM354-577v-69.5h69.5v69.5H354Zm139 0v-69.5h69.5v69.5H493Zm69.5-69.5V-716H632v69.5h-69.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportScoreIcon);
export default __webpack_public_path__ + "static/media/SportScoreIcon.678e8e57f1a8f99dec63856d4a05a4fa.svg";
export { ForwardRef as ReactComponent };